import styled from 'styled-components';

export const LinkComponent = styled.a`
  text-decoration: underline;
`;